import React from "react";
import { useGetTimes } from "../../hooks";
import { checkIfInPeriod, getWeekYear } from "../../utils";
import { ColumnHead, WeekDayWrapper } from "../StyledComponents";
import TimeCell from "./TimeCell";
import { useSelector } from "../../../../store/store";
import { getDailyIndividualConsultations } from "../../../../store/data";
import { format } from "date-fns";

interface Props {
    dayName: string;
    dayDate: Date;
    dayDateString: string;
    dayIndex: number;
    week: number;
}

const WeekDay = ({
    dayName,
    dayIndex,
    dayDate,
    dayDateString,
    week,
}: Props) => {
    const times = useGetTimes(dayDate);
    const weekYear = getWeekYear(week);

    const dailyConsultations = useSelector(
        getDailyIndividualConsultations({
            year: weekYear,
            week,
            index: dayIndex,
        })
    );

    return (
        <WeekDayWrapper>
            <ColumnHead>
                <div>{dayName}</div>
                <div>{dayDateString}</div>
            </ColumnHead>
            {times.map((time) => (
                <TimeCell
                    key={time.getTime()}
                    time={time}
                    isConsultation={checkIfInPeriod(
                        dailyConsultations,
                        format(time, "HH:mm")
                    )}
                ></TimeCell>
            ))}
        </WeekDayWrapper>
    );
};

export default React.memo(WeekDay);
